import React from 'react';

export default function Error404() {
    return (
      <h2>Error 404 Page Not Found</h2>  
    );
} 